import { createContext, RefObject, useContext } from "react";

import { Schema } from "./types";

export interface SchemaFormContextValue {
  schema: Schema;
  // Form path the schema root is mounted at, e.g. "ai_settings"
  rootPath: string;
  // The record as loaded (none for a new record), to tell which masked secrets the API keeps
  stored?: unknown;
  // Validation message per schema-relative path
  errors: Record<string, string>;
  // Values of fields that were switched off, restored when they are switched on again
  valueCache: RefObject<Record<string, unknown>>;
}

export const SchemaFormContext = createContext<SchemaFormContextValue | null>(
  null,
);

export const useSchemaForm = () => {
  const context = useContext(SchemaFormContext);

  if (!context) {
    throw new Error("SchemaForm fields must be rendered inside a SchemaForm");
  }

  return context;
};

// The react-hook-form name of a schema path
export const useFieldName = (path: string) => {
  const { rootPath } = useSchemaForm();

  if (!rootPath) return path;
  return path ? `${rootPath}.${path}` : rootPath;
};

export const useFieldError = (path: string) => useSchemaForm().errors[path];
